import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { T2B, T2M, T2R, T4R } from '../Text';

import { media } from '../../styles/constants';

import { parseShortcodeArray } from '../../helpers/shortcode';

const IntroContainer = styled.div`
  display: flex;
  flex-direction: column;

  && {
    ${T4R} {
      font-weight: 400;
      padding-top: 2rem;

      @media (min-width: ${media.tabletLandscape}) {
        padding-top: 1.5rem;
      }
    }

    ${T2B} {
      padding-top: 1.5rem;
    }
  }

  @media (min-width: ${media.tabletLandscape}) {
    flex-direction: row;
  }
`;

const renderLinks = links => (
  <div>
    <T2B>Visit</T2B>
    {links.map((elem, i) => (
      <div key={`${elem.text}-${i}`}>
        <a href={elem.link} rel="noopener noreferrer">
          <T2M>{elem.text}</T2M>
        </a>
      </div>
    ))}
  </div>
);

const renderServices = services => (
  <div>
    <T2B>Services</T2B>
    {services.map((elem, i) => (
      <T2R key={`${elem}-${i}`}>{elem}</T2R>
    ))}
  </div>
);

const VerticalContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 0rem;

  @media (min-width: ${media.tabletLandscape}) {
    flex-grow: 1;
    flex-shrink: 0;
    flex-basis: 30%;
    padding-right: 4rem;
    margin-bottom: 0;
  }

  &:first-child {
    padding-bottom: 0;
  }

  > div {
    display: flex;
    flex-direction: column;

    > div,
    > span {
      padding-bottom: 1rem;
    }
  }
`;

const Intro = ({
  links: rawLinksString,
  services: rawServicesString,
  caption
}) => {
  let links = null;
  let services = null;

  if (rawLinksString) {
    // Remove the double quotes at the start and end of the string to be able to parse
    links = parseShortcodeArray(rawLinksString);
  }

  if (rawServicesString) {
    services = rawServicesString.split(', ');
  }

  return (
    <IntroContainer>
      <VerticalContainer>
        {links && renderLinks(links)}
        {services && renderServices(services)}
      </VerticalContainer>
      <T4R>{caption}</T4R>
    </IntroContainer>
  );
};

Intro.propTypes = {
  links: PropTypes.string,
  services: PropTypes.string,
  caption: PropTypes.string
};

export default Intro;
